/* MyGenie — Conversion Features JS */

function mgIsInStock(product) {
  if (!product.variants || !product.variants.length) return false;
  return product.variants.some(function(v) { return v.available; });
}
window.mgIsInStock = mgIsInStock;

var mgFmt = function(cents) {
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
};

document.addEventListener('DOMContentLoaded', function() {

  /* ── Replace Afterpay with Google Pay badge on PDP ── */
  var apLine = document.getElementById('mg-payment-line');
  if (apLine) {
    var svg = '<svg style="width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;vertical-align:middle;margin-right:4px" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>';
    apLine.innerHTML = svg + 'Secure checkout with <span class="mg-gpay-brand">Google Pay</span>, Visa &amp; Mastercard';
  }
  document.body.classList.add('mg-ready');

  /* ── Global text replacements ── */
  var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
  var nd;
  var reps = [
    ['Afterpay', 'Google Pay'],
    ['afterpay', 'Google Pay']
  ];
  while ((nd = tw.nextNode())) {
    var t = nd.nodeValue, ch = false;
    for (var i = 0; i < reps.length; i++) {
      if (t.indexOf(reps[i][0]) !== -1) { t = t.split(reps[i][0]).join(reps[i][1]); ch = true; }
    }
    if (ch) nd.nodeValue = t;
  }

  /* ── PDP: You May Also Like ── */
  var pdpWrap = document.querySelector('[data-mg-product-id]');
  if (pdpWrap) {
    var productId = pdpWrap.getAttribute('data-mg-product-id');
    var infoCol = pdpWrap.querySelector('[data-mg-pdp-info]');
    if (infoCol && productId) {
      var recsWrap = document.createElement('div');
      recsWrap.className = 'mg-pdp-recs';
      recsWrap.id = 'mg-pdp-recs';
      infoCol.appendChild(recsWrap);

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=16&intent=related')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.products || !data.products.length) return;
        var prods = data.products.filter(mgIsInStock).slice(0, 6);
        if (!prods.length) return;
        var html = '<div class="mg-pdp-recs__label">You May Also Like</div>';
        html += '<div class="mg-pdp-recs__grid">';
        prods.forEach(function(p) {
          var img = p.featured_image ? p.featured_image : (p.images && p.images.length ? p.images[0].src : '');
          if (img) img = img.replace(/(\.[\w]+)(\?|$)/, '_400x$1$2');
          var price = mgFmt(p.variants[0].price);
          var compare = p.variants[0].compare_at_price && p.variants[0].compare_at_price > p.variants[0].price
            ? '<span class="mg-pdp-recs__compare">' + mgFmt(p.variants[0].compare_at_price) + '</span>' : '';
          var save = '';
          if (p.variants[0].compare_at_price && p.variants[0].compare_at_price > p.variants[0].price) {
            var pct = Math.round((p.variants[0].compare_at_price - p.variants[0].price) / p.variants[0].compare_at_price * 100);
            save = '<span class="mg-pdp-recs__save">Save ' + pct + '%</span>';
          }
          html += '<a href="/products/' + p.handle + '" class="mg-pdp-recs__card">';
          html += '<div class="mg-pdp-recs__imgbox">';
          if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy" class="mg-pdp-recs__img">';
          if (save) html += '<span class="mg-pdp-recs__badge">Sale</span>';
          html += '</div>';
          html += '<div class="mg-pdp-recs__info">';
          html += '<div class="mg-pdp-recs__name">' + p.title + '</div>';
          html += '<div class="mg-pdp-recs__price">' + price + ' ' + compare + ' ' + save + '</div>';
          html += '</div></a>';
        });
        html += '</div>';
        recsWrap.innerHTML = html;
      })
      .catch(function() {});

      /* ── Low stock indicator ── */
      var lowStockEl = document.createElement('div');
      lowStockEl.className = 'mg-pdp__low-stock';
      lowStockEl.id = 'mg-low-stock';
      lowStockEl.style.display = 'none';
      lowStockEl.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> <span>Low stock — order soon</span>';
      var priceAnchor = pdpWrap.querySelector('[data-mg-price-anchor]');
      if (priceAnchor && priceAnchor.nextSibling) {
        priceAnchor.parentNode.insertBefore(lowStockEl, priceAnchor.nextSibling);
      } else if (infoCol) {
        infoCol.insertBefore(lowStockEl, infoCol.firstChild);
      }
    }
  }

  /* ── Cart page: Customers Also Bought ── */
  var cartRecsTarget = document.getElementById('mg-cart-recs');
  if (cartRecsTarget) {
    var firstProductId = cartRecsTarget.getAttribute('data-first-product-id');
    var cartProductIds = (cartRecsTarget.getAttribute('data-cart-ids') || '').split(',').map(Number).filter(Boolean);
    if (firstProductId) {
      fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=8&intent=related')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.products || !data.products.length) return;
        var recs = data.products
          .filter(function(p) { return cartProductIds.indexOf(p.id) === -1 && mgIsInStock(p); })
          .slice(0, 4);
        if (!recs.length) return;
        var html = '<div class="mg-cart-recs__label">Customers Also Bought</div>';
        html += '<div class="mg-cart-recs__grid">';
        recs.forEach(function(p) {
          var img = p.featured_image ? p.featured_image : (p.images && p.images.length ? p.images[0].src : '');
          if (img) img = img.replace(/(\.[\w]+)(\?|$)/, '_400x$1$2');
          var price = mgFmt(p.variants[0].price);
          var compare = p.variants[0].compare_at_price && p.variants[0].compare_at_price > p.variants[0].price
            ? '<span class="mg-cart-rec-card__compare">' + mgFmt(p.variants[0].compare_at_price) + '</span>' : '';
          var vid = p.variants[0].id;
          var avail = p.variants[0].available;
          html += '<div class="mg-cart-rec-card">';
          html += '<a href="/products/' + p.handle + '" class="mg-cart-rec-card__img-link">';
          if (img) html += '<img class="mg-cart-rec-card__img" src="' + img + '" alt="' + p.title + '" loading="lazy">';
          html += '</a>';
          html += '<div class="mg-cart-rec-card__info">';
          html += '<a href="/products/' + p.handle + '" class="mg-cart-rec-card__name">' + p.title + '</a>';
          html += '<div class="mg-cart-rec-card__prices"><span class="mg-cart-rec-card__price">' + price + '</span>' + compare + '</div>';
          if (avail) {
            html += '<button type="button" class="mg-cart-rec-card__atc" data-variant-id="' + vid + '">+ Add to Cart</button>';
          } else {
            html += '<span class="mg-cart-rec-card__soldout">Sold Out</span>';
          }
          html += '</div></div>';
        });
        html += '</div>';
        var wrap = document.createElement('div');
        wrap.className = 'mg-cart-recs';
        wrap.innerHTML = html;
        cartRecsTarget.appendChild(wrap);

        cartRecsTarget.addEventListener('click', function(e) {
          var btn = e.target.closest('.mg-cart-rec-card__atc');
          if (!btn) return;
          var vid2 = btn.getAttribute('data-variant-id');
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(vid2), quantity: 1 })
          })
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function() {
            btn.textContent = '\u2713 Added!';
            btn.classList.add('mg-cart-rec-card__atc--added');
            setTimeout(function() { location.reload(); }, 1200);
          })
          .catch(function() {
            btn.textContent = 'Error';
            btn.disabled = false;
            setTimeout(function() { btn.textContent = '+ Add to Cart'; }, 2000);
          });
        });
      })
      .catch(function() {});
    }
  }

  /* ── Collection page: Quick Add buttons ── */
  document.querySelectorAll('[data-mg-pcard]').forEach(function(card) {
    var href = card.getAttribute('href') || card.querySelector('a[href*="/products/"]');
    if (typeof href !== 'string') href = href ? href.getAttribute('href') : null;
    if (!href) return;
    var handle = href.replace('/products/', '').split('?')[0];
    var body = card.querySelector('[data-mg-pcard-body]');
    if (!body) return;
    var btn = document.createElement('button');
    btn.className = 'mg-pcard__quick-add';
    btn.type = 'button';
    btn.setAttribute('data-handle', handle);
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
    body.appendChild(btn);
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.mg-pcard__quick-add');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/products/' + handle + '.js')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(product) {
      if (!product) throw new Error();
      var variant = product.variants.find(function(v) { return v.available; });
      if (!variant) { btn.textContent = 'Sold Out'; btn.disabled = true; return Promise.resolve(null); }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
    })
    .then(function(r) { if (r && !r.ok) throw new Error(); return r ? r.json() : null; })
    .then(function(item) {
      if (!item) return;
      btn.innerHTML = '\u2713 Added!';
      btn.classList.add('mg-pcard__quick-add--added');
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
      setTimeout(function() {
        btn.classList.remove('mg-pcard__quick-add--added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add';
        btn.disabled = false;
      }, 2000);
    });
  });

  /* ── Global Search Overlay ── */
  (function() {
    var searchEl = document.getElementById('mg-search');
    var input = document.getElementById('mg-search-input');
    var results = document.getElementById('mg-search-results');
    var closeBtn = document.getElementById('mg-search-close');
    if (!searchEl || !input) return;
    var debounceTimer = null;
    var fmtDollars = function(d) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(parseFloat(d)); };
    function openSearch() { searchEl.classList.add('is-open'); searchEl.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(function() { input.focus(); }, 150); }
    function closeSearch() { searchEl.classList.remove('is-open'); searchEl.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; input.value = ''; results.innerHTML = '<div class="mg-search__hint">Start typing to search…</div>'; }
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-mg-search-toggle]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest('.mg-search__overlay')) closeSearch();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchEl.classList.contains('is-open')) closeSearch();
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
    });
    input.addEventListener('input', function() {
      var q = this.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { results.innerHTML = '<div class="mg-search__hint">Start typing to search…</div>'; return; }
      results.innerHTML = '<div class="mg-search__loading">Searching…</div>';
      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (!data || !data.resources || !data.resources.results || !data.resources.results.products) {
            results.innerHTML = '<div class="mg-search__empty"><div class="mg-search__empty-title">No results found</div><div class="mg-search__empty-sub">Try a different search term</div></div>'; return;
          }
          var products = data.resources.results.products;
          if (!products.length) {
            results.innerHTML = '<div class="mg-search__empty"><div class="mg-search__empty-title">No products found for \u201C' + q + '\u201D</div><div class="mg-search__empty-sub">Try a different keyword</div></div>'; return;
          }
          var html = '';
          products.forEach(function(p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[\w]+)(\?|$)/, '_120x$1$2') : '';
            var price = fmtDollars(p.price_min);
            var compare = p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(p.price_min)
              ? '<span class="mg-search__item-compare">' + fmtDollars(p.compare_at_price_min) + '</span>' : '';
            html += '<a href="' + p.url + '" class="mg-search__item">';
            html += '<img class="mg-search__item-img" src="' + img + '" alt="' + p.title + '" loading="lazy">';
            html += '<div class="mg-search__item-info">';
            html += '<div class="mg-search__item-vendor">' + (p.vendor || '') + '</div>';
            html += '<div class="mg-search__item-title">' + p.title + '</div>';
            html += '<div><span class="mg-search__item-price">' + price + '</span>' + compare + '</div>';
            html += '</div></a>';
          });
          html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="mg-search__view-all">View all results for \u201C' + q + '\u201D &rarr;</a>';
          results.innerHTML = html;
        })
        .catch(function() {
          results.innerHTML = '<div class="mg-search__empty"><div class="mg-search__empty-title">Something went wrong</div><div class="mg-search__empty-sub">Please try again</div></div>';
        });
      }, 300);
    });
  })();

  /* ── Cart drawer: in-stock cross-sell upsell strip ── */
  function mgLoadDrawerUpsell(productId, cartIds) {
    var wrap = document.getElementById('mg-drawer-upsell-wrap');
    if (!wrap || !productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (!data || !data.products || !data.products.length) return;
      var recs = data.products
        .filter(function(p) { return cartIds.indexOf(p.id) === -1 && mgIsInStock(p); })
        .slice(0, 4);
      if (!recs.length) return;
      var html = '<div class="mg-drawer-upsell"><div class="mg-drawer-upsell__label">Complete the set</div><div class="mg-drawer-upsell__items">';
      recs.forEach(function(p) {
        var img = p.featured_image ? p.featured_image : (p.images && p.images.length ? p.images[0].src : '');
        if (img) img = img.replace(/(\.[\w]+)(\?|$)/, '_300x$1$2');
        var price = mgFmt(p.variants[0].price);
        html += '<a href="/products/' + p.handle + '" class="mg-drawer-upsell__item">';
        if (img) html += '<img class="mg-drawer-upsell__img" src="' + img + '" alt="' + p.title + '" loading="lazy">';
        html += '<span class="mg-drawer-upsell__name">' + p.title + '</span>';
        html += '<span class="mg-drawer-upsell__price">' + price + '</span>';
        html += '</a>';
      });
      html += '</div></div>';
      wrap.innerHTML = html;
    })
    .catch(function() {});
  }
  window.mgLoadDrawerUpsell = mgLoadDrawerUpsell;

});
